export const updateArray = <T>(state: T[], item: T, key: keyof T): T[] => {
  const newState = [...state]

  const index = newState.findIndex(i => i[key] === item[key])

  if (index !== -1) {
    newState.splice(index, 1)
  } else {
    newState.push(item)
  }

  return newState
}

export function sortByKey(array, key) {
  // Create a copy of the array to avoid modifying the original read-only array
  const arrayCopy = [...array];
  return arrayCopy.sort((a, b) => {
      if (a[key] < b[key]) {
          return -1;
      }
      if (a[key] > b[key]) {
          return 1;
      }
      return 0;
  });
}

export function getAllValues(obj) {
  let values = [];
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (typeof obj[key] === 'object' && obj[key] !== null) {
        values = values.concat(getAllValues(obj[key]));
      } else {
        values.push(obj[key]);
      }
    }
  }
  return values;
}

export function getKeyValues(root) {
  const keyValues = []
  const visited = new Set()

  const targets = [root]
  while(targets.length) {
    const target = targets.shift()

    if (visited.has(target)) {
      continue // skip circular references
    }
    visited.add(target)

    const pairs = Object.entries(target)
    keyValues.push(...pairs) // current key-value pairs

    for (const [key, value] of pairs) {
      if (value && typeof value === 'object') {
        targets.push(value) // include nested
      }
    }
  }

  return keyValues
}

/**
 * Read values for a set of keys, supporting **dot-paths** ('product.title') so nested
 * fields are searchable — e.g. the certificate picker searches the product title, which
 * lives at `product.title` not the top level (VERA-455). Missing paths yield undefined.
 */
export function getValuesByKeys(obj: any, keys: string[]): any[] {
  return keys.map(key =>
    key.split('.').reduce<any>((acc, part) => (acc == null ? undefined : acc[part]), obj),
  );
}

export function multiSort(arr: MyObject[], sortOrders: { [key: string]: 'asc' | 'desc' }): MyObject[] {
  // Create a copy of the array to avoid modifying the original read-only array
  const arrCopy = [...arr];
  return arrCopy.sort((a, b) => {
    for (const key in sortOrders) {
      const order = sortOrders[key];
      let comparison = 0;

      // check nested keys
      const pathArray = key.split(".");
      let aKey = a;
      for (const part of pathArray) {
        aKey = aKey[part];
      }
      let bKey = b 
      for (const part of pathArray) {
        bKey = bKey[part];
      }
      
      if (aKey < bKey) {
        comparison = -1;
      } else if (aKey > bKey) {
        comparison = 1;
      }

      if (comparison !== 0) {
        return order === 'asc' ? comparison : -comparison;
      }
    }
    return 0; // Return 0 if all properties are equal
  });
}